export default __webpack_public_path__ + "static/media/junglebook.f1d213f9.png";